import { createFileRoute, Link } from "@tanstack/react-router";
import { useState } from "react";
import { usePatients } from "@/hooks/api/use-api";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Search, ChevronRight } from "lucide-react";

export const Route = createFileRoute("/patients/")({
  component: PatientsList,
});

function PatientsList() {
  const [q, setQ] = useState("");
  const { data, isLoading } = usePatients(q);

  return (
    <div className="space-y-4 p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold tracking-tight">Patients</h1>
        <Badge variant="outline">{data?.total ?? 0} total</Badge>
      </div>
      <div className="relative">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
        <Input
          placeholder="Rechercher (nom, CIN, CNSS, MRN)"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          className="pl-9"
        />
      </div>

      <div className="grid gap-2">
        {isLoading ? (
          Array.from({ length: 6 }).map((_, i) => <Skeleton key={i} className="h-16 w-full" />)
        ) : (
          data?.items.map((p) => (
            <Link
              key={p.id}
              to={`/patients/$patientId`}
              params={{ patientId: p.id }}
              className="group flex items-center justify-between rounded-lg border border-white/10 bg-white/[0.03] p-4 transition hover:bg-white/[0.06]"
            >
              <div className="flex-1">
                <div className="font-medium">{p.family} {p.given}</div>
                <div className="mt-1 flex items-center gap-2 text-xs text-muted-foreground">
                  <span>{p.mrn}</span>
                  {p.nationalId && <span>· CIN {p.nationalId}</span>}
                  {p.bloodGroup && <span>· {p.bloodGroup}</span>}
                  {p.phone && <span>· {p.phone}</span>}
                </div>
              </div>
              <ChevronRight className="h-4 w-4 text-muted-foreground opacity-0 transition group-hover:opacity-100" />
            </Link>
          ))
        )}
        {!isLoading && data?.items.length === 0 && (
          <div className="rounded-lg border border-dashed border-white/10 p-8 text-center text-sm text-muted-foreground">
            Aucun patient trouvé
          </div>
        )}
      </div>
    </div>
  );
}
